
import { UserModule } from "@/store/modules/user";
import { Component, Vue } from "vue-property-decorator";

@Component({})
export default class extends Vue {
    private show: boolean = false;
    private status: boolean = false;

    get info() {
        return UserModule.chatsNums;
    }

    private messageRouter(){
        this.$router.push({
            path: "/chatroom"
        });
    }
}
